import { RestrictedCompanyModel } from "../../common/models/CommonModels";
import { ResourceLoadingState, AddResourceState } from "../../common/store/stateHelpers";
import { Reducer } from "redux";

export enum ActionType {
    RequestRestrictions = "RESTRICTIONS/REQUEST",
    ReceivedRestrictions = "RESTRICTIONS/RECEIVED",
    AddRestriction = "RESTRICTIONS/ADD",
    AddStarted = "RESTRICTIONS/ADD_STARTED",
    AddSubmitted = "RESTRICTIONS/ADD_SUBMITTED",
    AddCancelled = "RESTRICTIONS/ADD_CANCELLED",
    AddSuccess = "RESTRICTIONS/ADD_SUCCESS",
    DeleteRestriction = "RESTRICTIONS/DELETE",
    DeleteStarted = "RESTRICTIONS/DELETE_STARTED",
    DeleteSubmitted = "RESTRICTIONS/DELETE_SUBMITTED",
    DeleteCancelled = "RESTRICTIONS/DELETE_CANCELLED",
    DeleteSuccess = "RESTRICTIONS/DELETE_SUCCESS",
}

interface RequestRestrictionsAction {
    type: ActionType.RequestRestrictions
}

interface ReceivedRestrictionsAction {
    type: ActionType.ReceivedRestrictions;
    data: RestrictedCompanyModel[]
}

export interface AddRestrictionAction {
    type: ActionType.AddRestriction
}

interface AddStartedAction {
    type: ActionType.AddStarted
}

interface AddSubmittedAction {
    type: ActionType.AddSubmitted;
    selected: string[]
}

interface AddCancelledAction {
    type: ActionType.AddCancelled
}

interface AddSuccessAction {
    type: ActionType.AddSuccess
}

export interface DeleteRestrictionAction {
    type: ActionType.DeleteRestriction,
    id: string;
}

export const actionCreators = {
    requestRestrictions: () => <RequestRestrictionsAction>{ type: ActionType.RequestRestrictions },
    receivedRestrictions: (data: RestrictedCompanyModel[]) => <ReceivedRestrictionsAction>{ type: ActionType.ReceivedRestrictions, data },
    addRestriction: () => <AddRestrictionAction>{ type: ActionType.AddRestriction },
    addStarted: () => <AddStartedAction>{ type: ActionType.AddStarted },
    addSubmitted: (selected: string[]) => <AddSubmittedAction>{ type: ActionType.AddSubmitted, selected },
    addCancelled: () => <AddCancelledAction>{ type: ActionType.AddCancelled },
    addSuccess: () => <AddSuccessAction>{ type: ActionType.AddSuccess },
    deleteRestriction: (id: string) => <DeleteRestrictionAction>{ type: ActionType.DeleteRestriction, id }
}

export type RestrictionsState = ResourceLoadingState<RestrictedCompanyModel> & AddResourceState

const initialState: RestrictionsState = {
    isLoading: false,
    data: [],
    addingNew: false
}

type RestrictionAction = RequestRestrictionsAction | ReceivedRestrictionsAction | AddStartedAction | AddSuccessAction

export const reducer: Reducer<RestrictionsState> = (state: RestrictionsState, action: RestrictionAction) => {
    switch (action.type) {
        case ActionType.RequestRestrictions:
            return {
                ...state,
                isLoading: true,
                data: []
            }
        case ActionType.ReceivedRestrictions:
            return {
                ...state,
                isLoading: false,
                data: action.data
            }
        case ActionType.AddStarted:
            return {
                ...state,
                addingNew: true
            }
        case ActionType.AddSuccess:
            return {
                ...state,
                addingNew: false
            }
        default:
            const exCheck: never = action;
    }

    return state || initialState;
}


// WEBPACK FOOTER //
// ./src/account/store/restrictionsStore.ts